<template>
  <div class="myorder" :class="{'no-product-section' : noResultFound}" :style="`padding-top:${couponCardHeight}px`">
    <show-scratch-card
      :scratchArrayValue="scratchArrayValue"
      :scratchSaleId="this.$route.query.orderId"
      :redeemId="scratchArrayValue.id"
      @closeScratch="closeScratch"
      :appId="137"
      v-if="isCloseScratch"
    />
    <!-- <h3 class="total-calc" v-if="orders.length">Total Orders : {{orders.length}}</h3> -->
    <div class="filter-option" :style="`top:${couponCardHeight}px`">     
     <!-- :style="[
        $route.query.tab
          ? { top: '0px' }
          : { top: '130px' },
      ]"  -->
      <p @click="selectFilterOption('PENDING')" :class="{'active' : filterOption === 'PENDING'}">{{$t('pending')}}</p>
      <p @click="selectFilterOption('DELIVERED')" :class="{'active' : filterOption === 'DELIVERED'}">{{$t('delivered')}}</p>
      <p @click="selectFilterOption('ALL')" :class="{'active' : filterOption === 'ALL'}">{{$t('all')}}</p>
      <p @click="selectFilterOption('TOCONFIRM')" :class="{'active' : filterOption === 'TOCONFIRM'}" v-if="$route.query.CLOUDSHOP">{{$t('toConfirm')}}</p>
      <p @click="selectFilterOption('DISTRIBUTORITEMS')" :class="{'active' : filterOption === 'DISTRIBUTORITEMS'}" v-if="$route.query.CLOUDSHOP">{{$t('items')}}</p>
    </div>
    <ul v-if="orders.length > 0 && filterOption !== 'DISTRIBUTORITEMS'">
      <li v-for="(order, index) in orders" :key="index">
      <div class="order-card" v-if="order.subOrderDTOList && order.subOrderDTOList.length">
        <p v-if="parseFloat(order.subOrderDTOList[0].gmallItemId)>0 && order.subOrderDTOList[0].gmallLocalSupply && !['CANCELLED_BY_SELLER','CANCELLED_BY_USER'].includes(order.orderState)" class="supply-type local">Local Supply</p>
        <p v-else-if="parseFloat(order.subOrderDTOList[0].gmallItemId)>0 && !order.subOrderDTOList[0].gmallLocalSupply && !['CANCELLED_BY_SELLER','CANCELLED_BY_USER'].includes(order.orderState)" class="supply-type godaam">Godaam Supply</p>
        <div class="product-details" @click="goToOrderDetail(order.orderId, order.orderState)">
          <span class="product-img" v-if="order.subOrderDTOList">
            <img :src="order.subOrderDTOList[0].itemImage" alt="product-image" />
          </span>
          <div class="product-info" :class="{'local-class':parseFloat(order.subOrderDTOList[0].gmallItemId)>0 && order.subOrderDTOList[0].gmallLocalSupply && !['CANCELLED_BY_SELLER','CANCELLED_BY_USER'].includes(order.orderState),'global-class':parseFloat(order.subOrderDTOList[0].gmallItemId)>0 && !order.subOrderDTOList[0].gmallLocalSupply && !['CANCELLED_BY_SELLER','CANCELLED_BY_USER'].includes(order.orderState)}">
            <div class="product-title">
              <h4 v-if="order.subOrderDTOList">{{ order.subOrderDTOList[0].itemName }}</h4>
            </div>
            <div class="color-size">
            <div v-if="order.subOrderDTOList[0].itemAttributeDTOs" v-for="itemAttribute in order.subOrderDTOList[0].itemAttributeDTOs">
            
              <span class="product-color" v-if="itemAttribute.itemAttributeName === 'Color'">
                {{$t('color')}} :&nbsp;
                <span class="colour">
                  <span style="text-transform:capitalize;font-weight: 500;">{{itemAttribute.itemAttributeValue }}</span>
                </span>
              </span>
               
              <span class="product-sz" v-if="itemAttribute.itemAttributeName === 'Size'">
                {{$t('size')}} :&nbsp;
                <span class="size">{{itemAttribute.itemAttributeValue }}</span>
              </span>
            </div>
            </div>
              <p class="date" style="padding-top:4px">
                Order ID  - <strong style=" color: #0091FF;">#{{ order.orderId }}   </strong>           
              </p>
              <p class="date" style="padding-top:4px">
                Order Date  - {{ order.orderDate.slice(0, order.orderDate.indexOf(',')) }}              
              </p>
          </div>
          <div  class="right-arrow">
          <right-arrow />
          </div>
        </div>
        <div v-if="order.orderState !== 'CANCELLED_BY_USER'" style="    border-top: 1px solid #ccc;">
          <div  class="customer-info" v-if="order.addressDTO.payboardEncodedId === order.subOrderDTOList[0].sellerLiteDTO.payboardEncodedId">
            <p class="name"> {{replcePhoneWithAsterik(order.subOrderDTOList[0].sellerLiteDTO.sellerName)}}
              </p>
              <p class="call">
                  <a :href="'tel:'+ order.subOrderDTOList[0].sellerLiteDTO.phone"><img src="../../assets/images/icons/ic_call.svg" /> Call</a>
              </p>
          </div>
          <div  class="customer-info" v-else-if="order.addressDTO.payboardEncodedId !== order.subOrderDTOList[0].sellerLiteDTO.payboardEncodedId && ($cookie.get('X-Auth-Id') === order.addressDTO.payboardEncodedId)">
            <p class="name"> {{replcePhoneWithAsterik(order.subOrderDTOList[0].sellerLiteDTO.sellerName)}}
              </p>
              <p class="call">
                  <a :href="'tel:'+ order.subOrderDTOList[0].sellerLiteDTO.phone"><img src="../../assets/images/icons/ic_call.svg" /> Call</a>
              </p>
          </div>
          <div  class="customer-info" v-else>
            <p class="name"> {{replcePhoneWithAsterik(order.addressDTO.personName)}}
              </p>
              <p class="call">
                  <a :href="'tel:'+ order.addressDTO.contactNumber"><img src="../../assets/images/icons/ic_call.svg" /> Call</a>
              </p>
          </div>
           <div class="customer-info" v-if="order.addressDTO.address">
            <p class="date flx"><strong style="line-height: 0;padding-right:4px"><span class="material-icons" style="font-size: 1.5em"
                >location_on</span
              ></strong>{{order.addressDTO.address}},{{order.addressDTO.city}}</p>
          </div>
          
            <div class="customer-info">
              <p class="date">Total Item : <strong>{{order.subOrderDTOList.length}}</strong></p>
              <p class="date">Total Price : <strong> Rs.{{Math.round(parseFloat(order.totalPaidAmount) + parseFloat(order.totalDiscountedAmount)) }}</strong></p>
            </div>
          
            <div v-if="order.orderPaymentStatus === 'PAYMENT_SUCCESSFUL'" class="price-detail">
              <p>
                You will pay:
                <span> Rs. 0 </span>
              </p>
              <p v-if="parseFloat(order.totalPaidAmount) > 0">
                Discount Applied:
                <span> Rs.{{ Math.round(parseFloat(order.totalDiscountedAmount)) }} </span>
              </p>
            </div>
            <div v-else-if="order.orderPaymentStatus === 'VERIFICATION_FAILED'" class="price-detail">
              <p>
                Payment under verification:
                <span> Pending </span>
              </p>                  
            </div>
            <div v-else class="price-detail">
              <p>
                Customer will pay:
                <span> Rs.{{ order.totalPaidAmount }} </span>
              </p>
              <p v-if="parseFloat(order.totalDiscountedAmount) > 0">
                Discount Applied:
                <span> Rs.{{ order.totalDiscountedAmount }} </span>
              </p>
            </div>
          </div>        
      </div>
      </li>
    </ul>
    <ul v-else>
      <li v-for="(order, index) in orders" :key="index">
      <div class="order-card">        
        <div class="product-details" @click="getItemDetail(index,order.itemId)">
          <span class="product-img">
            <img :src="order.itemImage" alt="product-image" />
          </span>
          <div class="product-info">
            <div class="product-title">
              <h4>{{ order.itemName }}</h4>
            </div>
              <p class="date" style="padding-top:4px">
                Total Sub Order  - <strong>{{ order.suborderCount }}   </strong>           
              </p>
              <p class="date" style="padding-top:4px">
                Qty  - <strong>{{ order.totalQuantity }}  </strong>            
              </p>
          </div>
          <div  class="right-arrow">
          <right-arrow />
          </div>
        </div>
        <div style="    border-top: 1px solid #ccc;" v-if="order.distributor">
          <div  class="customer-info">
            <p class="name"><span style="font-weight: 500;color: #727272;font-size: 0.875em;">Distributor Name - </span> {{order.distributor.name}}</p>
            <p class="call">
                <a :href="'tel:'+ order.distributor.phone"><img src="../../assets/images/icons/ic_call.svg" /> Call</a>
            </p>
          </div>
          <div class="customer-info">
            <p class="date flx"><span style="font-weight:500">Address - </span>  {{order.distributor.address}},{{order.distributor.city}},{{order.distributor.pincode}}</p>
          </div>
          </div>        
      </div>
      <!-- <div class="bottomToUp" v-if="isShopOrderList === index"></div>
      <div class="bottomToUp_content item-deliver" :class="{'activeBottomtoUp' : isShopOrderList}" v-if="isShopOrderList === index"> -->
        <shop-order-list v-if="isShopOrderList === index" :itemId="order.itemId" @closePopUp="isShopOrderList = !isShopOrderList" @markedDispatch="getDispatchList"/>
      <!-- </div> -->
      </li>
    </ul>
    <infinite-loading @infinite="getOrdersListing" :identifier="resetIdentifier" spinner="circles" :class="{'visibilityHidden':noResultFound}" style="    color: #fff !important;">
      <template slot="no-more">{{$t('noMoreRecord')}}</template>
    </infinite-loading>
    <div class="no-product" v-if="noResultFound">
      <div class="no-item-found">
        <div class="img-block">
            <img src="../../assets/images/ic_product_box.svg" />
        </div>
        <div class="details-block">
            <p>अभी तक आपको कोई भी आर्डर नहीं मिला है</p>
        </div>
        </div>
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import constant from "../../utils/constant";
import InfiniteLoading from "vue-infinite-loading";
import ShowScratchCard from "../../components/OrderHistorySection/ShowScratchCard";
import CustomToaster from "../../components/Common/CustomToaster";
import ApiCaller from "../../utils/apicaller";
import RightArrow from '../../components/Icons/RightArrow';
import { replcePhoneWithAsterik } from '../../utils/helper';
import ShopOrderList from './ShopOrderList'
import Vue from "vue";
export default {
  name: "MyOrders",
  components: {
    InfiniteLoading,
    ShowScratchCard,
    CustomToaster,
    RightArrow,
    ShopOrderList
  },
  data() {
    return {
      isCloseScratch: false,
      scratchArrayValue: {},
      limit: 20,
      orderIndex: 0,
      orders: [],
      isToasterData: false,
      noResultFound: false,
      filterOption: "PENDING",
      loading: false,
      resetIdentifier: +new Date(),
      isShopOrderList: false
    };
  },
  props: {
    couponCardHeight: {

    }
  },
  methods: {
    replcePhoneWithAsterik,
    getText(orderStatus) {
      let obj = constant.GETTEXT;
      return obj[orderStatus];
    },
    getDispatchList(){
      this.isShopOrderList = !this.isShopOrderList
      this.orders = [],
      this.orderIndex = 0,
      this.loading = true;
      this.filterOption == 'DISTRIBUTORITEMS'
      setTimeout(() => { 
        this.resetIdentifier +=1;
      }, 1000);
    },
    goToOrderDetail(orderId, status) {
      this.$cookie.set("orderStatus", "myshop_order");
      if(this.$route.query.CLOUDSHOP && this.filterOption === 'TOCONFIRM'){
        this.$router.push("/order-by-suborder/?byOrderId=" + orderId + '&CLOUDSHOP=YES');
      }else{
        this.$router.push("/order-by-suborder/?byOrderId=" + orderId);
      }
      
    },
    getItemDetail(index,itemId){
      ApiCaller(
            constant.LOCAL_SHOP_URL_ORDER,
              `get-shop-order-list-for-item/${this.$route.query.shopid}/${itemId}/${this.limit}/${0}`,
            "get"
          ).then(data =>{
            if(data && data.data.length){
              this.isShopOrderList = index
            }
          }).catch(err=>{
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.getItemDetail(index,itemId);
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }else{
              this.loading = false;
            }
          })
    },
    goToShoppingGroup(id) {
      try {
        this.loading = false;
        JSBridgePlugin.joinMall91Group(id);
        try {
          JSBridgePlugin.fireEvents("JOIN_GROUP");
        } catch (err) {
          console.log(err);
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    selectFilterOption(value){
      if(this.filterOption != value){
        this.filterOption = value;
         this.$store.commit("saveData", {
          localShopOrders: [],
          localShopIndex: 0,
          type: "localshop_orders",
        });
        this.orders = [],
        this.orderIndex = 0,
        this.loading = true
        setTimeout(() => { 
          this.resetIdentifier +=1;
        }, 1000);
      }
      
    },
    getOrdersListing($state) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        let payloadObject ;
        let endPointValue;
        if(['PENDING','DELIVERED','ALL'].includes(this.filterOption)){
          endPointValue = 'get-user-order/'
        }else if(['TOCONFIRM'].includes(this.filterOption)){
          endPointValue = 'get-cloud-shop-transfer-order/'
        }else if(['DISTRIBUTORITEMS'].includes(this.filterOption)){
          endPointValue = `order-distributor-data/${this.$route.query.shopid}/`
        }
        if(['PENDING','DELIVERED','ALL'].includes(this.filterOption)){
          payloadObject = "?orderType=myShopOrders&filterBy=" + this.filterOption
        }else if(['TOCONFIRM'].includes(this.filterOption)){
          payloadObject = ''
        }else if(['DISTRIBUTORITEMS'].includes(this.filterOption)){
          payloadObject = ''
        }else{
          payloadObject = "?orderType=myShopOrders&filterBy=PENDING"
        }
          ApiCaller(
            constant.LOCAL_SHOP_URL_ORDER,
            endPointValue + this.limit + '/' +  this.orderIndex + payloadObject,
            "get"
          )
          .then((data) => {
            this.loading = false;
            if (data.data.length > 0) {              
              this.orders.push(...data.data);
              this.orderIndex += 1;
              this.$store.commit("saveData", {
                orders: this.orders,
                orderIndex: this.orderIndex,
                filterBy: this.filterOption,
                type: "myshop_order",
              });
              this.noResultFound = false
              $state && $state.loaded();
              
            } else {    
              this.loading = false          
              $state && $state.complete();
            }
            if(this.orders.length == 0){
                this.noResultFound = true
              }
          })
          .catch((err) => {
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.getOrdersListing($state);
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }else{
              this.loading = false;
              $state && $state.complete();
            }
          });
      }
    },
    closeScratch() {
      this.isCloseScratch = !this.isCloseScratch;
    },
    getScratchValue() {
      const obj = {
        identifierSource: "ORDER",
        identifierId: this.$route.query.orderId,
        applicationId: "137",
      };
      this.$store
        .dispatch({
          type: "getScratchValue",
          payload: obj,
        })
        .then((data) => {
          if (data) {
            this.isCloseScratch = true;
            if (
              data &&
              data.data.status == "ACTIVE" &&
              data.data.scratchcardDTO.cardStatus == "INVISIBLE"
            ) {
              this.scratchArrayValue = data.data;
            } else if (
              this.scratchArray.status == "ACTIVE" &&
              this.scratchArray.scratchcardDTO.cardStatus == "ACTIVE"
            ) {
              this.scratchArrayValue = data.data;
            }
          } else {
            console.log("already scracthed");
          }
        }).catch(err =>{
          if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = res => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.getScratchCard();
                } else {
                  this.loading = false;
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          }
        })
    },
  },
  mounted() {
    if (this.$store.getters.orders && this.$store.getters.orders.length > 0) {
      this.orders = this.$store.getters.orders;
      this.orderIndex = this.$store.getters.orderIndex;
      this.filterOption = this.$store.getters.filterBy
    }
  },
};
</script>

<style lang="scss" scoped>
.myorder{
  padding: 0;
      padding-top: 8px;
  background-color: #f4f6f8;
  ul{
    padding: 0 15px 15px;
  }
}
.filter-option{
  display: flex;
    justify-content: center;
    padding: 8px 8px;
    position: sticky;
    // top: 130.5px;
    background: white;
    z-index: 99;
    /* box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.22); */
    border-radius: 10px; 
    margin-bottom: 8px;
    width: 100%;
    left: 0;
  p{
    padding: 8px;
    border-radius: 10px;
    border: 1px solid #ccc;
    width: 25%;
    text-align: center;
    margin: 0 4px;
    font-size: 0.75em;
    font-weight: 600;
    background: white;
    white-space: nowrap;
    &.active{
      background: orange;
      border: 1px solid orange;
      color: #fff;
    }
  }
}
.myorder ul li{
  box-shadow: none;
  border-radius: none;
  padding: 0;
  margin-bottom: 15px;
}
.myorder ul li .order-card{
      width: 100%;
    -webkit-box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08); 
    border: solid 1px rgba(221, 221, 221, 0.39);
    background-color: #ffffff;
    padding: 10px 8px;
     margin-bottom: 0;
    border-radius: 10px;
     position: relative;
      .isMallItem{
        position: absolute;
        right: 0;
        top: 0;
        background: red;
        color: #fff;
        font-size: 0.85em;
        padding: 2px 8px;
        border-top-right-radius: 8px;
        font-weight: 600;
      }
      .supply-type{
          position: absolute;
          top: 0;
          right: 0;
          background: red;
          color: #fff;
          padding: 4px 10px;
          font-size: 0.75em;
          border-bottom-right-radius: 4px;
          &.local{
            background: orange;
          }
          &.godaam{
            background: green;
          }
        }
}
</style>